import { useEffect, useState } from "react";
import firstImg from "../../../assets-user/topimg.png";
import secondImg from "../../../assets-user/midImg.png";
import thirdImg from "../../../assets-user/bottomImg.png";
import fourthImg from "../../../assets-user/mainImg.png";
import { useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import HomePropertyCard from "../userCommon/HomePropertyCard";
import HomePropertyCardSkeleton from "../userCommon/HomePropertyCardSkeleton";
const underConstructionProperties = [
  {
    _id: "UC1",
    thumbnail: firstImg,
    price: 3000000, // 30L - typical pre-launch pricing
    title: "Upcoming 2 BHK Smart Apartment",
    location: "Tamando, AIIMS Road, Bhubaneswar",
    listedBy: { role: "agent-builder" },
    createdAt: "2024-12-05T09:00:00Z",
  },
  {
    _id: "UC2",
    thumbnail: secondImg,
    price: 4200000, // 42L
    title: "Pre-Launch 3 BHK Residential Tower",
    location: "Chandaka, Near Tech Corridor, Bhubaneswar",
    listedBy: { role: "super-admin" },
    createdAt: "2024-11-28T13:20:00Z",
  },
  {
    _id: "UC3",
    thumbnail: thirdImg,
    price: 3600000, // 36L
    title: "Under-Construction Urban 2 BHK",
    location: "Mancheswar, Near Railway Colony, Bhubaneswar",
    listedBy: { role: "agent-builder" },
    createdAt: "2024-12-18T11:40:00Z",
  },
  {
    _id: "UC4",
    thumbnail: fourthImg,
    price: 5500000, // 55L
    title: "Premium High-Rise 3 BHK (Phase 1)",
    location: "Rasulgarh, Near NH16, Bhubaneswar",
    listedBy: { role: "buyer-owner" },
    createdAt: "2024-12-25T16:10:00Z",
  },
];

const UnderConstruction = () => {
  const [properties, setProperties] = useState(underConstructionProperties);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  useEffect(() => {
    // const fetchProperties = async () => {
    //   try {
    //     setLoading(true);
    //     const res = await api.get("/properties/home?type=residential&count=5");
    //     const data = res.data?.data || [];
    //     setProperties(data.slice(0, 5));
    //   } catch (err) {
    //     console.error("Error fetching properties:", err);
    //   } finally {
    //     setLoading(false);
    //   }
    // };
    // fetchProperties();
  }, []);

  return (
    <div className="w-full  ">
      <div className="mx-auto">
        {/* Header */}
        <div className="flex justify-between items-center pb-6 lg:pb-8">
          <h2 className="font-medium text-[#031722] text-lg sm:text-xl md:text-2xl ">
            Under Construction
          </h2>

          <button
            onClick={() => {
              navigate("/properties");
              window.scrollTo(0, 0);
            }}
            className="flex items-center gap-1 sm:gap-2 text-red-600 font-medium text-xs sm:text-base "
          >
            View all <ArrowRight className="w-3 sm:w-4 h-3 sm:h-4" />
          </button>
        </div>

        {/* SMART RESPONSIVE GRID */}
        <div className="flex gap-4 overflow-x-auto scrollbar-none snap-x snap-mandatory xl:grid xl:grid-cols-4 xl:overflow-x-visible xl:snap-none">
          {!loading &&
            properties?.map((property, i) => (
              <div
                key={property?._id || i}
                className="snap-start shrink-0 w-[75%] sm:w-[50%] md:w-[33%] xl:w-auto xl:max-w-sm"
              >
                <HomePropertyCard property={property} redirectAllowed={false} />
              </div>
            ))}

          {loading &&
            Array.from({ length: 4 }).map((_, i) => (
              <div
                key={"skeleton-" + i}
                className="snap-start shrink-0 w-[75%] sm:w-[50%] md:w-[33%] xl:w-auto xl:max-w-sm"
              >
                <HomePropertyCardSkeleton />
              </div>
            ))}
        </div>
      </div>
    </div>
  );
};

export default UnderConstruction;

// import { useState } from "react";
// import { motion } from "framer-motion";
// import { Heart } from "lucide-react";
// import firstImg from "../../../assets-user/topimg.png";
// import secondImg from "../../../assets-user/midImg.png";
// import thirdImg from "../../../assets-user/bottomImg.png";
// import fourthImg from "../../../assets-user/mainImg.png";

// const UnderConstruction = () => {
//   const [wishlist, setWishlist] = useState([]);

//   const toggleWishlist = (propertyId) => {
//     setWishlist((prev) =>
//       prev.includes(propertyId)
//         ? prev.filter((id) => id !== propertyId)
//         : [...prev, propertyId]
//     );
//   };

//   const properties = [
//     {
//       id: 1,
//       image: firstImg,
//       verified: true,
//       price: "₹2.5 Cr",
//       title: "2 BHK Appartment",
//       location: "Kalinga Nagar, Near TATA Areana, Sum Hospital Road",
//       postedBy: "Posted By Dealer",
//       timeAgo: "1 Months ago",
//     },
//     {
//       id: 2,
//       image: secondImg,
//       verified: true,
//       price: "₹2.5 Cr",
//       title: "2 BHK Appartment",
//       location: "Kalinga Nagar, Near TATA Areana, Sum Hospital Road",
//       postedBy: "Posted By Dealer",
//       timeAgo: "1 Months ago",
//     },
//     {
//       id: 3,
//       image: thirdImg,
//       verified: true,
//       price: "₹2.5 Cr",
//       title: "2 BHK Appartment",
//       location: "Kalinga Nagar, Near TATA Areana, Sum Hospital Road",
//       postedBy: "Posted By Dealer",
//       timeAgo: "1 Months ago",
//     },
//     {
//       id: 4,
//       image: fourthImg,
//       verified: true,
//       price: "₹2.5 Cr",
//       title: "2 BHK Appartment",
//       location: "Kalinga Nagar, Near TATA Areana, Sum Hospital Road",
//       postedBy: "Posted By Dealer",
//       timeAgo: "1 Months ago",
//     },
//   ];

//   return (
//     <div className="w-full">
//       <div className="mx-auto">
//         {/* Header */}
//         <h2 className="font-medium text-[24px] text-[#031722] mb-1 sm:mb-2 md:mb-3 lg:mb-4">
//           UnderConstruction
//         </h2>

//         {/* Property Grid */}
//         <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 sm:gap-5 lg:gap-6">
//           {properties.map((property, index) => (
//             <motion.div
//               key={property.id}
//               className="bg-white rounded-lg shadow-md overflow-hidden cursor-pointer"
//               initial={{ opacity: 0, y: 60, scale: 0.95 }}
//               whileInView={{ opacity: 1, y: 0, scale: 1 }}
//               viewport={{ once: false, amount: 0.3 }} // repeatable on revisit
//               transition={{
//                 duration: 0.6,
//                 delay: index * 0.15,
//                 ease: "easeOut",
//               }}
//               whileHover={{
//                 scale: 1.05,
//                 boxShadow: "0px 20px 40px rgba(0,0,0,0.15)",
//               }}
//             >
//               {/* Image Container */}
//               <div className="relative h-48 sm:h-52 lg:h-56 overflow-hidden">
//                 <motion.img
//                   src={property.image}
//                   alt={property.title}
//                   className="w-full h-full object-cover"
//                   whileHover={{ scale: 1.1 }}
//                   transition={{ duration: 0.5 }}
//                 />

//                 {/* Verified Badge */}
//                 {property.verified && (
//                   <div className="absolute top-3 left-3 bg-green-500 text-white text-xs font-medium px-2 py-1 rounded-md flex items-center gap-1">
//                     <span>✓</span>
//                     <span>Verified</span>
//                   </div>
//                 )}

//                 {/* Heart Icon */}
//                 <button
//                   onClick={() => toggleWishlist(property.id)}
//                   className="absolute top-3 right-3 bg-white/90 hover:bg-white p-2 rounded-full transition-all duration-200 hover:scale-110"
//                 >
//                   <Heart
//                     className={`w-4 h-4 sm:w-5 sm:h-5 transition-colors duration-200 ${
//                       wishlist.includes(property.id)
//                         ? "fill-red-500 text-red-500"
//                         : "text-gray-600"
//                     }`}
//                   />
//                 </button>

//                 {/* Price Badge */}
//                 <div className="absolute bottom-3 right-3 bg-white px-3 py-1 rounded-md">
//                   <span className="text-sm sm:text-base font-semibold text-[#424242]">
//                     {property.price}
//                   </span>
//                 </div>
//               </div>

//               {/* Content */}
//               <div className="p-4">
//                 <h3 className="font-medium text-[#031722] text-base sm:text-lg md:text-xl lg:text-[18.7px] mb-2">
//                   {property.title}
//                 </h3>
//                 <p className="font-normal text-[#6A6A6A] text-sm sm:text-base md:text-[14.54px] mb-2">
//                   {property.location}
//                 </p>
//                 <div className="flex items-center justify-between font-normal text-[#797979] text-xs sm:text-sm md:text-[12.46px]">
//                   <span>{property.postedBy}</span>
//                   <span>{property.timeAgo}</span>
//                 </div>
//               </div>
//             </motion.div>
//           ))}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default UnderConstruction;
